import { getTeams } from '@/api/team';

type ITeamInfo = ITeam.IResponse.ITeamInfo;
type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;

export let companyAllTeam: ITeamInfo[] = [];
export let companyActiveTeam: ITeamInfo[] = [];

export const getCompanyAllTeam = () => {
  return new Promise((resolve, reject) => {
    getTeams({
      pageindex: 1,
      pagesize: 1000,
    }).then((res) => {
      companyAllTeam = res.data;
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};

export const getCompanyActiveTeam = () => {
  return new Promise((resolve, reject) => {
    getTeams({
      active: true,
      returnMember: true,
      pageindex: 1,
      pagesize: 200,
    }).then((res) => {
      companyActiveTeam = res.data;
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};

const filterLeaderTeams = (leaderId: string): IUserDetailInfo[] => {
  const leaderTeams = companyActiveTeam.filter((team) => {
    // 判断是不是负责人
    if (team.leader === leaderId) {
      return true;
    }
    // 判断是不是管理员
    if (team.manager.findIndex((manager) => manager.id === leaderId) > -1) {
      return true;
    }
    return false;
  });
  const allMembers: IUserDetailInfo[] = [];
  const members: IUserDetailInfo[] = [];
  const memberIds: string[] = [];
  leaderTeams.forEach((team) => {
    allMembers.push(...team.members);
  });
  allMembers.forEach((member) => {
    if (!memberIds.includes(member.id)) {
      memberIds.push(member.id);
      members.push(member);
    }
  });
  return members;
};

export const generateLeaderTeams = (leaderId: string): Promise<IUserDetailInfo[]> => {
  return new Promise((resolve, reject) => {
    getCompanyActiveTeam().then(() => {
      resolve(filterLeaderTeams(leaderId));
    }).catch(() => {
      resolve([]);
    });
  });
};

export const initCompanyActiveTeam = async () => {
  if (companyActiveTeam.length === 0) {
    try {
      await getCompanyActiveTeam();
      return Promise.resolve(companyActiveTeam);
    } catch (error) {
      return Promise.reject(error);
    }
  } else {
    return Promise.resolve(companyActiveTeam);
  }
};
